import { render } from "./AgentsPage.vue?vue&type=template&id=764033aa&scoped=true&ts=true"
import script from "./AgentsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentsPage.vue?vue&type=script&lang=ts&setup=true"

import "./AgentsPage.vue?vue&type=style&index=0&id=764033aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764033aa"],['__file',"src/pages/agents/AgentsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "764033aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('764033aa', __exports__)) {
    api.reload('764033aa', __exports__)
  }
  
  module.hot.accept("./AgentsPage.vue?vue&type=template&id=764033aa&scoped=true&ts=true", () => {
    api.rerender('764033aa', render)
  })

}


export default __exports__